import React from 'react'
import { changeScreen, changeScreenB } from '../../../store/actions/navigation.action'
import { useDispatch, useSelector } from 'react-redux'
import { Drawer } from '@material-ui/core'
import Metrics from '../metrics'
import MetricsRegion from '../metrics/region'
import MetricsUtms from '../metrics/utms'
import Links from '../links'
import LinksEdit from '../links/edit'
import PixelEdit from '../pixel/edit'
import GoogleEdit from '../google/edit'
import WebhookEdit from '../webhooks/edit'

import ChartCampaign from '../campaigns/chart/campaign'
import ChartCampaigns from '../campaigns/chart'

import ChartLinks from '../links/chart'
import ChartLink from '../links/chart/link'

const style = {
    width: '680px',
    maxWidth: window.innerWidth
}

export default function Navigation(props) {
    const dispatch = useDispatch()
    const nav = useSelector(state => state.navigationReducer)

    return (
        <>
            <Drawer 
                anchor="right"
                open={nav.screen.open}
                onClose={() => dispatch(changeScreen({ open: false }))}
            >
                <div className="max-width" style={style}>
                    {(nav.screen.type === 'pixel-create' || nav.screen.type === 'pixel-edit') &&
                        <PixelEdit
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'google-create' || nav.screen.type === 'google-edit') &&
                        <GoogleEdit
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'webhook-create' || nav.screen.type === 'webhook-edit') &&
                        <WebhookEdit
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'metrics') &&
                        <Metrics 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'metrics-region') &&
                        <MetricsRegion 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'metrics-utms') &&
                        <MetricsUtms
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'chart-campaign') &&
                        <ChartCampaign 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'chart-campaigns') &&
                        <ChartCampaigns 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'links') &&
                        <Links 
                            uid={nav.screen.props.uid}
                        />
                    }
                </div>
            </Drawer>

            <Drawer 
                anchor="right"
                open={nav.screenB.open}
                onClose={() => dispatch(changeScreenB({ open: false }))}
            >
                <div className="max-width" style={style}>

                    {(nav.screenB.type === 'links-create' || nav.screenB.type === 'links-edit') &&
                        <LinksEdit
                            uid={nav.screenB.props.uid}
                            campaign_id={nav.screenB.props.campaign_id}
                        />
                    }

                    {(nav.screenB.type === 'metrics') &&
                        <Metrics 
                            uid={nav.screenB.props.uid}
                            link_id={nav.screenB.props.link_id}
                        />
                    }

                    {(nav.screenB.type === 'chart-links') &&
                        <ChartLinks 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screenB.type === 'chart-link') &&
                        <ChartLink
                            uid={nav.screenB.props.uid}
                            campaign_id={nav.screenB.props.campaign_id}
                        />
                    }
                </div>
            </Drawer>
        </>
    )
}